<template>

    <div class="component_4 myapplication__table__wrapper">
      <v-data-table
        :headers="$getHeaderType1(headerTxt, headers)"
        :items="representatives"
        hide-default-footer
        disable-pagination
        class="new__type__table"
      >
        <template v-slot:item="{ item, index }">
          <tr>
            <td>
              {{ index + 1 }}
            </td>
            <td>
              <p>{{ item.name_ar }}</p>
              <p>{{ item.name_en }}</p>
            </td>
            <td>
              <p>{{ item.address_ar }}</p>
              <p>{{ item.address_en }}</p>
            </td>
            <td>
              <div class="d-flex">
                <v-btn icon @click="fnGetRepresentativesDetail(item.seq)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon @click="fnDeleteRepresentativeConfirm(item.seq)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-row class="ma-0 mt-15">
        <v-col class="pa-0 d-flex" cols="12">

          <v-spacer class="d-inline-flex"></v-spacer>
          <v-btn
            dense
            outlined
            dark
            color="#a01c2a"
            width="110px"
            height="40px"
            v-show="isNewable"
            @click="fnNewRepresentative()"
          >
            {{ $t('common.button.add') }}
          </v-btn>
        </v-col>
      </v-row>

      <RepresentativeMod
        :seq.sync="representative_seq"
        :receipt_no.sync="receipt_no"
        v-if="mod_dialog"
        @success="fnSuccess()"
      />

      <RepresentativeAdd
        :receipt_no.sync="receipt_no"
        :addParams.sync="addParams"
        v-if="add_dialog"
        @success="fnSuccess()"
      />

      <v-dialog v-model="confirm_dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{ $t('common.message.delete.confirm.title') }}</v-card-title>
          <v-card-text>{{ $t('common.message.delete.confirm.text') }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="sb_btn btn-actv" @click="fnDeleteRepresentative()">{{ $t('common.button.yes') }}</v-btn>
            <v-btn class="sb_btn btn-dactv" @click="confirm_dialog = false">{{ $t('common.button.no') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>

</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import RepresentativeMod from './AmendmentRepresentativeMod'
import RepresentativeAdd from './AmendmentRepresentativeAdd'

export default {
  props : {
    receipt_no: String,
    auto_insert: Boolean,
    userInfo: Object,
    company: Object
  },
  components : {
    RepresentativeMod,
    RepresentativeAdd
  },
  data() {
    return {
      mod_dialog: false,
      add_dialog: false,
      confirm_dialog: false,
      representative_seq: 0,

      isNewable: true,

      headerTxt : {
        prefix : 'component.amendment_representative.fields.',
        txt : [ '#', 'name','address','' ]
      },

      headers: [
        { text: '#', align: 'center', width: '50px', sortable: false},
        { text: 'Name', align: 'center', sortable: false, width : '180px'},
        { text: 'Address', align: 'center', width: '*' ,sortable: false, },
        { text: '',  align: 'center', width: '100px', sortable: false, },
      ],
      representatives: [],

      addParams : {
        nationality_code : '',
        residence_country_code : '',
        name_ar : '',
        name_en : '',
        address_ar : '',
        address_en : '',
        pobox_ar : '',
        pobox_en : '',
        birthday_date: '',
        gender_type_code : '',
        telephone : '',
        mobile : '',
        fax : '',
        email : ''
      }
    }
  },
  mounted(){
    this.fnGetRepresentatives()
  },
  methods: {
    fnGetRepresentatives(){
      if(this.receipt_no != ''){
        requestApi({
          url: '/receivings/amendment/'+this.receipt_no+'/representatives',
          method: 'GET',
          callback: (res) => {
            if (res.res_code === '200') {
              this.representatives = res.data.list

              if(this.representatives.length == 0){
                this.$emit('empty', true)
              }else{
                this.$emit('empty', false)
              }

              if(this.representatives.length == 0 && this.auto_insert){
                this.fnSetAddForm()
              }else{
                this.clearAddForm()
              }

              this.setNewButtonStatus(res.data.list)

              this.mod_dialog = false
              this.add_dialog = false

            } else {
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnGetRepresentatives()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },

    fnSuccess(){
      requestApi({
        url: '/receivings/amendment/'+this.receipt_no+'/representatives',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.representatives = res.data.list

            if(this.representatives.length == 0){
              this.$emit('empty', true)
            }else{
              this.$emit('empty', false)
            }

            if(this.representatives.length == 0 && this.auto_insert){
              this.fnSetAddForm()
            }else{
              this.clearAddForm()
            }

            this.setNewButtonStatus(res.data.list)

            this.mod_dialog = false
            this.add_dialog = false

            this.$emit('success', res.data.list.length)

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSuccess()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    setNewButtonStatus(representativeList){
      //이미 사용된 Applicant 배열
      let used_applicant = []

      //representative 리스트에 All로 등록된게 존재 한다면 중지 하고 버튼 노출은 중지 (5101)
      for(let i=0; i<representativeList.length; i++){
        let representativeItem = representativeList[i]

        if(representativeItem.rep_scope_type_code == '5101'){
          this.isNewable = false
          return

        }else{
          let applicants = representativeItem.applicants

          for(let k=0; k<applicants.length; k++){
            used_applicant.push(applicants[k].seq)
          }
        }
      }

      requestApi({
        url: '/receivings/amendment/'+this.receipt_no+'/applicants',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            //모든 applicant목록
            let applicantList = res.data.list

            let count = res.data.list.length

            for(let i=0; i<applicantList.length; i++){
              for(let k=0; k<used_applicant.length; k++){
                if(applicantList[i].seq == used_applicant[k]){
                  count = count - 1
                }
              }
            }

            if(count > 0){
              this.isNewable = true
            }else{
              this.isNewable = false
            }

            this.$emit('SET_REPRESENTATIVE_NEWABLE', this.isNewable)
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.setNewButtonStatus(representativeList)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnSetAddForm(){
      this.addParams.nationality_code = this.userInfo.nationality_code
      this.addParams.birthday_date = this.userInfo.birthday_date
      this.addParams.gender_type_code = this.userInfo.gender_type_code
      //개인사용자 (2704, 2705)
      if(this.userInfo.user_type_code == '2704' || this.userInfo.user_type_code == '2705'){
        this.addParams.name_ar = this.userInfo.name_ar
        this.addParams.name_en = this.userInfo.name_en
        this.addParams.address_ar = this.userInfo.address_ar
        this.addParams.address_en = this.userInfo.address_en
        this.addParams.pobox_ar = this.userInfo.pobox
        this.addParams.pobox_en = this.userInfo.pobox
        this.addParams.telephone = this.userInfo.telephone
        this.addParams.mobile = this.userInfo.mobile
        this.addParams.fax = this.userInfo.fax
        this.addParams.email = this.userInfo.email
      }else{
        this.addParams.name_ar = this.company.name_ar
        this.addParams.name_en = this.company.name_en
        this.addParams.address_ar = this.company.address_ar
        this.addParams.address_en = this.company.address_en
        this.addParams.pobox_ar = this.company.pobox
        this.addParams.pobox_en = this.company.pobox
        this.addParams.telephone = this.company.telephone
        this.addParams.mobile = this.company.mobile
        this.addParams.fax = this.company.fax
        this.addParams.email = this.company.representative_email
      }
    },

    clearAddForm(){
      this.addParams.nationality_code = ''
      this.addParams.residence_country_code = ''
      this.addParams.name_ar = ''
      this.addParams.name_en = ''
      this.addParams.address_ar = ''
      this.addParams.address_en = ''
      this.addParams.pobox_ar = ''
      this.addParams.pobox_en = ''
      this.addParams.birthday_date= ''
      this.addParams.gender_type_code = ''
      this.addParams.telephone = ''
      this.addParams.mobile = ''
      this.addParams.fax = ''
      this.addParams.email = ''
    },

    //Representative 상세보기 팝업
    fnGetRepresentativesDetail(representative_seq){
      this.representative_seq = representative_seq
      this.mod_dialog = true
    },

    fnDeleteRepresentativeConfirm(representative_seq){
      this.representative_seq = representative_seq
      this.confirm_dialog = true
    },

    //Representative 삭제
    fnDeleteRepresentative(){
      requestApi({
        url: '/receivings/amendment/'+this.receipt_no+'/representatives/'+this.representative_seq,
        method: 'DELETE',
        callback: (res) => {
          if (res.res_code === '200') {
            let option = {
              text : this.$t('common.message.delete.success'),
            }
            eventBus.$emit('SHOW_SNACKBAR', option)
            this.fnSuccess()

            this.confirm_dialog = false
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnDeleteRepresentative()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    //Representative 신규팝업
    fnNewRepresentative(){
      this.add_dialog = true
    }
  },
}

</script>